import { ResourceMultimediaPipe } from "@utils/image/resource.multimedia.pipe";
import {
  CanalNotificationWithMessageCountDto,
  CreateRessourceMultimediaDto,
  INotificationsWebServiceClient,
  SaveCanalNotificationDto,
  TypeAutorisationEnum,
  TypeDiffusionEnum,
  TagLightDto
} from "@resources/resources";
import { TypeDiffusionEnums } from "@common/enum/typediffusion.enum";
import { TypeAutorisationEnums } from "@common/enum/typeautorisation.enum";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AsiFileService } from "@asi-ngtools/lib";

@Component({
  selector: 'enregistrement-canal-component',
  templateUrl: './enregistrement.canaux.component.html',
  host: { 'class': 'page' }
})
export class EnregistrementCanalComponent {

  canalForm: FormGroup;
  canal: CanalNotificationWithMessageCountDto;
  tags: TagLightDto[];
  imageSrc: string;


  constructor(private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private notificationsWebServiceClient: INotificationsWebServiceClient, private fileUtils: AsiFileService,
    private resourcePipe: ResourceMultimediaPipe) {

  }

  ngOnInit() {
    this.canal = this.activatedRoute.snapshot.data['canal'];
    this.tags = this.activatedRoute.snapshot.data['tags'];

    if (this.canal) {
      this.canalForm = this.fb.group({
        nom: [this.canal.nom, Validators.required],
        code: [this.canal.code, Validators.required],
        description: [this.canal.description],
        obligatoire: [this.canal.obligatoire],
        autoSubscribe: [this.canal.autoSubscribe],
        avecConfirmation: [this.canal.avecConfirmation],
        typeDiffusion: [this.canal.typeDiffusion, Validators.required],
        tags: [this.canal.tags.map(tag => this.tags.find(t => t.code === tag))],
        typeAutorisation: [this.canal.typeAutorisation, Validators.required],
        actif: [this.canal.actif],
        icone: [null, Validators.required],
        historique: [!this.canal.counted]
      });

      this.imageSrc = this.resourcePipe.transform(this.canal.imageId);
    } else {
      this.canalForm = this.fb.group({
        nom: [null, Validators.required],
        code: [null, Validators.required],
        description: [null],
        obligatoire: [null],
        autoSubscribe: [null],
        avecConfirmation: [null],
        typeDiffusion: [null, Validators.required],
        tags: [null],
        typeAutorisation: [null, Validators.required],
        actif: [null],
        icone: [null, Validators.required],
        historique: [false]
      });
    }
  }

  goCanaux() {
    this.router.navigate(['cerba/canaux']);
  }

  submit() {
    if (!this.canalForm.valid) {
      return;
    }
    const newCanal: SaveCanalNotificationDto = {
      id: this.canal ? this.canal.id : undefined,
      nom: this.canalForm.value.nom,
      code: this.canalForm.value.code,
      description: this.canalForm.value.description,
      obligatoire: this.canalForm.value.obligatoire,
      autoSubscribe: this.canalForm.value.autoSubscribe,
      avecConfirmation: this.canalForm.value.avecConfirmation,
      typeDiffusion: this.canalForm.value.typeDiffusion,
      typeAutorisation: this.canalForm.value.typeAutorisation,
      actif: this.canalForm.value.actif,
      counted: !this.canalForm.value.historique
    };

    let tags = [];
    if(this.canalForm.value.tags != null){
      tags = this.canalForm.value.tags.filter((tag:TagLightDto) => tag).map((tag:TagLightDto) => tag.code);
    }

    if (TypeDiffusionEnums.TAG.value() == newCanal.typeDiffusion && tags.length > 0) {
      const newTags = [].concat(tags);
      newCanal.tags = newTags;
    } else {
      newCanal.tags = null;
    }


    const photo = new CreateRessourceMultimediaDto();
    const fichier: File = this.canalForm.value.icone;

    this.fileUtils.fileToBase64(fichier).subscribe(result => {
      result = result.substring(result.indexOf(",") + 1);

      photo.content = result.toString();
      photo.name = fichier.name;
      photo.mimeType = fichier.type;
      photo.size = fichier.size;
      newCanal.image = photo;

      if (this.canal) {
        if (this.canal.id) {
          this.notificationsWebServiceClient.updateCanalNotification(this.canal.id, newCanal).subscribe(() => {
            this.router.navigate(['cerba/canaux']);
          });
          return;
        }
      }
      this.notificationsWebServiceClient.createCanalNotification(newCanal).subscribe(() => {
        this.router.navigate(['cerba/canaux']);
      });
    });
  }

  // Méthode pour vérifier si le type de diffusion du formulaire est le type TAG
  isTypeDiffusionTag(): boolean {
    return this.canalForm.value.typeDiffusion == TypeDiffusionEnums.TAG.value();
  }

  // Méthode de récupération des types de diffusion
  getTypesDiffusion(): Array<TypeDiffusionEnum> {
    return TypeDiffusionEnums.values();
  }

  // Méthode de récupération des types d'autorisation'
  getTypesAutorisation(): Array<TypeAutorisationEnum> {
    return TypeAutorisationEnums.values();
  }

  public modifierValidation(typeDiffusion: TypeDiffusionEnum) {
    if (typeDiffusion == "TAG") {
      this.canalForm.controls.tags.setValidators([Validators.required]);
    } else {
      this.canalForm.controls.tags.clearValidators();
    }
    this.canalForm.controls.tags.updateValueAndValidity();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/enregistrement/enregistrement.canaux.component.ts